export default {
  "overviewTitle": "Association plan overview",
  "core": "Key metrics",
  "noPrevious": "No data for last month",
  "trendTitle": "Association plan revenue over the last 6 months",
  "topTitle": "Top 10 subscribing organizations",
  "rank": "Rank",
  "association": "Association / organization",
  "planVersion": "Plan version",
  "amountActivated": "Activation amount",
  "noActivations": "No association activations yet",
  "sourceDistribution": "Association source distribution",
  "sourceCenter": "Activation\nsource",
  "statusDistribution": "Association status distribution",
  "statusCenter": "Association\nstatus",
  "monthActivated": "Associations activated this month",
  "monthRevenue": "Plan revenue this month",
  "totalRevenue": "Total plan revenue",
  "totalActivated": "Total activated associations",
  "planTitle": "Association plan management",
  "addPlan": "New plan",
  "planGuide": "Configure plans for activating association mini-program services for designated organizations. Configuring a plan does not activate services or create payment records.",
  "defaultDescription": "Mini-program services for associations.",
  "free": "Free",
  "displayFeatures": "Display features",
  "edit": "Edit",
  "delete": "Delete",
  "emptyPlans": "No association plans configured yet",
  "editPlan": "Edit plan",
  "basic": "Basic information",
  "name": "Plan name",
  "tag": "Tag",
  "tagPlaceholder": "e.g. Popular, Flagship",
  "price": "Price (CNY)",
  "duration": "Term",
  "permanent": "Permanent",
  "year": "Yearly",
  "durationYears": "Term (years)",
  "theme": "Theme color",
  "status": "Status",
  "listed": "Listed",
  "unlisted": "Unlisted",
  "description": "Description",
  "features": "Included features",
  "onePerLine": "One item per line",
  "featurePlaceholder": "One item per line, e.g.\nEvent registration\nMember management\nHome page design",
  "featureHint": "Displayed on the plan page only; does not change permissions. One item per line, up to 30.",
  "cancel": "Cancel",
  "save": "Save",
  "home": "Home page design",
  "members": "Member management",
  "join": "Membership applications",
  "contacts": "Directory",
  "associationIntro": "Association profile",
  "articles": "News management",
  "organization": "Organization structure",
  "activities": "Event management",
  "albums": "Event albums",
  "fees": "Membership fee payments",
  "blue": "Blue",
  "purple": "Purple",
  "cyan": "Cyan",
  "green": "Green",
  "orange": "Orange",
  "pink": "Pink",
  "gray": "Gray",
  "nameRequired": "Enter a plan name",
  "priceRequired": "Enter a price",
  "featuresRequired": "Enter display features",
  "yearsRequired": "Set the term in years",
  "permanentValid": "Never expires",
  "saved": "Plan saved",
  "deleteTitle": "Delete plan",
  "deleted": "Plan deleted",
  "recordsTitle": "Activation records",
  "recordsHint": "Paid or manually activated association services. Pause, resume, or renew services for another year.",
  "company": "Organization",
  "plan": "Plan",
  "amount": "Amount",
  "activatedAt": "Activated at",
  "active": "Active",
  "paused": "Paused",
  "actions": "Actions",
  "pause": "Pause",
  "resume": "Resume",
  "renew": "Renew for one year",
  "emptyRecords": "No activation records yet",
  "updated": "Updated",
  "renewTitle": "Renew service",
  "navTitle": "Association plans",
  "navOverview": "Overview",
  "navPlans": "Association plans",
  "navRecords": "Activations",
  "change": "vs. last month",
  "trendNote": "Currency: CNY · Peak {amount}",
  "associationCount": "{n} associations",
  "years": "{n} years",
  "defaultFeatures": "Home page design\nEvent management\nMember management",
  "deleteConfirm": "Delete “{name}”?",
  "renewConfirm": "Renew services for “{name}” for one year?",
  "sourceSelf": "Website self-service",
  "sourceProxy": "Liaison invitation",
  "sourceEnterprise": "Company referral",
  "normal": "Active",
  "soon30": "Expiring within 30 days",
  "expired": "Expired"
}
